import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authorization-gate/orgs/$orgName/projects/$projectId/revisions/$revisionId/')({
	beforeLoad: () => {
		throw Route.redirect({ to: './results', params: (prev) => prev });
	},
});
